import { useState } from "react";
import { useNavigate } from "react-router";
import { ColorButton } from "../../../../common/components/button/colorButton/ColorButton";
import { RowMessage } from "../../../../common/components/common/RowMessage/RowMessage";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { constructUserHref } from "../../../../common/infrastructure/routes/routePaths";
import { IPlannerEventUserModel } from "../models/plannerEventUserModel";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { FormSubmissionDialog } from "../../../../common/preReservationForms/FormSubmissionDialog";
import styles from "./PlannerEventReservationDetailsUser.module.scss";
import parentStyles from "./PlannerEventReservationDetails.module.scss";

interface IPreReservationFormSubmissionViewModel {
  renderedHtml: string;
  createdOn: string;
}

interface IPlannerEventReservationDetailsUserProps {
  user: IPlannerEventUserModel;
}
export const PlannerEventReservationDetailsUser = ({
  user,
}: IPlannerEventReservationDetailsUserProps) => {
  const navigate = useNavigate();
  const [showFormSubmission, setShowFormSubmission] = useState(false);

  const { data: formSubmission } =
    useApiQuery<IPreReservationFormSubmissionViewModel | null>({
      queryKey: [
        endpointsMetadata.preReservationForm.getSubmissionByUserEvent,
        user.userEventId,
      ],
      endpoint: `${endpointsMetadata.preReservationForm.getSubmissionByUserEvent}?userEventId=${user.userEventId}`,
      enabled: !!user.userEventId,
      globalIsLoading: false,
    });

  const goToUserProfile = () => {
    if (user) {
      const href = constructUserHref(user.id);
      navigate(href);
    }
  };

  return (
    <div className={styles.userInfo_content}>
      <div className={styles.userInfo_content_name}>
        {user?.name}{" "}
        <span className={styles.userInfo_content_name_id}>(#{user.id})</span>
      </div>
      <div className={styles.userInfo_content_phone}>
        <Icon type={IconType.Phone} color="#ffffffd9" />
        {user?.phoneNumber}
      </div>
      <div className={styles.userInfo_content_email}>
        <Icon type={IconType.Envelope} color="#ffffffd9" />
        {!!user?.email ? user?.email : "N/A"}
      </div>

      <RenderWhen condition={user.isUnreliable}>
        <RowMessage
          type="error"
          message={"НЕРЕДОВЕН ПОТРEБИТЕЛ"}
          className={styles.userInfo_content_unreliable}
        />
      </RenderWhen>

      <ColorButton
        className={parentStyles.common_small_button}
        label={"Отвори профила на потребителя"}
        backgroundColorHex={"#259b74ff"}
        textColorHex={"#fff"}
        onClick={goToUserProfile}
      />

      <RenderWhen condition={!!formSubmission?.renderedHtml}>
        <ColorButton
          className={parentStyles.common_small_button}
          label={"Виж попълнената форма"}
          backgroundColorHex={"#3b7dd8ff"}
          textColorHex={"#fff"}
          onClick={() => setShowFormSubmission(true)}
        />
      </RenderWhen>

      <FormSubmissionDialog
        visible={showFormSubmission}
        onHide={() => setShowFormSubmission(false)}
        renderedHtml={formSubmission?.renderedHtml}
      />
    </div>
  );
};
